import React from 'react'
import { IRentalTermsModel } from './RentalTermModel'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'

type Props = {
  data: IRentalTermsModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit?: (rentalTerm: IRentalTermsModel) => void
  onDelete?: (rentalTerm: IRentalTermsModel) => void
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const RentalTermTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false
}) => {
  const rentalTermColumns: TableColumn<IRentalTermsModel>[] = [
    { key: 'index', label: 'Kayıt No', className: 'fw-semibold', sortable: true },
    {
  key: 'branchId',              // ID backend için
  label: 'Şube Adı',
  className: 'fw-semibold',
  sortable: true,
  render: (row) => row.branchName || row.branchId, // Görüntüleme branchName
},
    {key: 'startDate',label: 'Başlangıç Tarihi',sortable: true,render: (row) => row.startDate,},
    {key: 'endDate',label: 'Bitiş Tarihi',sortable: true,render: (row) => row.endDate,},
    { key: 'minimumDays', label: 'Minimum Gün', sortable: true,render: (row) => row.minimumDays },
    { key: 'dayCalculationType', label: 'Gün Hesaplama Tipi' },
  ]

  const rentalTermActions: TableAction<IRentalTermsModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (rentalTerm) => onEdit?.(rentalTerm),
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (rentalTerm) => onDelete?.(rentalTerm),
    },
  ]

  return (
    <DataTable
      data={data}
      columns={rentalTermColumns}
      actions={rentalTermActions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz Kiralama Şartı bulunamadı'
    />
  )
}
